import React, { useState, useEffect } from "react";
import styles from "./AboutUs.module.css";
import project1 from "../img/image1.jpeg";
import project2 from "../img/image2.jpg";
import project3 from "../img/image3.png";
import { FaCheckCircle } from "react-icons/fa";
import AOS from "aos";
import "aos/dist/aos.css";
import { Helmet } from "react-helmet";
import { FaMobileAlt, FaHeart, FaPencilRuler, FaHandsHelping } from "react-icons/fa";
import Swal from 'sweetalert2';

const AboutUs = () => {

  const [name, setName] = useState('');
  const [message, setMessage] = useState('');
  const [email, setEmail] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
  
    const formData = new FormData(form);
    const response = await fetch('https://api.web3forms.com/submit', {
      method: 'POST',
      body: formData,
    });
  
    if (response.ok) {
      Swal.fire('Success!', 'Your message has been sent.', 'success');
      // Clear form fields
      setName('');
      setEmail('');
      setMessage('');
      form.reset(); // Also clears hidden fields like access_key
    } else {
      Swal.fire('Error!', 'Something went wrong.', 'error');
    }
  };

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);


  const handleChange = (e) => {
    let value = e.target.value;
    if (value.length === 1) {
      value = value.toUpperCase();
    }
    setName(value);
  };


  const handleMessageChange = (e) => {
    let value = e.target.value;
    if (value.length > 0) {
      value = value.charAt(0).toUpperCase() + value.slice(1);
    }
    setMessage(value);
  };

  return (
    <>
      <Helmet>
        <title>AK Technologies</title>
      </Helmet>

      <div className={styles.stackedWrapper}>
        <div className={styles.centeredContainer} data-aos="fade-up">
          <div className={styles.stackedSection} data-aos="fade-up">
            <div className={styles.imageBox} data-aos="fade-up">
            </div>
            <div className={styles.textCard} data-aos="fade-up">
              <h2>
                We’re here to help businesses <span>grow</span> and evolve through
                innovation.
              </h2>
              <p className="p-tag">
                At AK technologies, we believe that innovation is more than just
                technology, it’s the mindset that drives meaningful transformation.
              </p>
              <p className="p-tag">
                Our diverse and passionate team brings together expertise in AI,
                autonomous systems, business strategy, and smart infrastructure.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div id="about" className={styles.missionSection}>
        <h3>ABOUT AK TECHNOLOGIES</h3>
        <p className="p-tag" data-aos="fade-up">
          AK technologies were established in 2022, with the aim of deriving and delivering cutting-edge innovative
          data-based solutions in response to challenges across a variety of problem areas. Our goal is to develop a
          team of experts who will provide the right solution to businesses, whilst creating a nurturing environment
          to thrive. We are always looking for an opportunity to prove our passion and with a team that comprises
          enthusiasts across autonomous sensing systems, artificial Intelligence, urban planning, and business development,
          our team is ready and committed to delivering excellence.
        </p>

        <h4>WHY CHOOSE US</h4>
        <div className={styles.whyChooseContainer} data-aos="fade-up">
          <ul className={styles.bulletList}>
            <li><FaCheckCircle /> Proven Expertise</li>
            <li><FaCheckCircle /> Quality Assurance</li>
            <li><FaCheckCircle /> Innovative Solutions</li>
            <li><FaCheckCircle /> Timely Delivery</li>
            <li><FaCheckCircle /> Customization</li>
            <li><FaCheckCircle /> Cost-Effective Solutions</li>
            <li><FaCheckCircle /> User-Centric Design</li>
            <li><FaCheckCircle /> Transparent Communication</li>
          </ul>
        </div>
      </div>

      {/* Features Section */}
      <div id="features" className={`${styles.featuresSection} ${styles.section}`}>
        <div className={styles.centeredContainer}>
          <h3 className={styles.headings} data-aos="fade-up">FEATURES</h3>
          <div className={styles.featureCards}>
            {[
              {
                title: "Responsive",
                icon: <FaMobileAlt />,
                description: "We help our clients to identify and effectively adapt to the continuous change in thier industry. Companies who effectively adapt to change are better able to manage disruption and consistently meet their customers’ expectations."

              },
              {
                title: "Passion",
                icon: <FaHeart />,
                description: "Our team is a group of technophiles and focusing on developing state-of-art technologies that helps our clients to increase efficiency, greater business agility and, ultimately, the unlocking of new value for employees, customers and shareholders."
              },
              {
                title: "Design",
                icon: <FaPencilRuler />,
                description: "Our design team works on the product development in three unqiue blocks Understand the problem and the opportunity. Define your product (and do it early!). Visualize your product."
              },
              {
                title: "Support",
                icon: <FaHandsHelping />,
                description: "Our team of experts provide end to end support for your business, ranging from new product development, existing product upgrade etc, as well provide support in, market research, brand management and fundraising."
              }
            ].map((feature, index) => (
              <div className={styles.featureCard} key={index} data-aos="fade-up">
                <div className={styles.iconWrapper}>{feature.icon}</div>
                <h4 style={{ fontWeight: "800", fontSize: "26px" }}>{feature.title}</h4>
                <p className="p-tag" style={{ color: "black" }}>{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>


      {/* Projects Section */}
      <div id="projects" className={styles.projectsSection}>
        <h3 className={styles.headingsss} data-aos="fade-up">PROJECTS</h3>
        <div className={styles.projectCards}>

          <div className={styles.projectCard} data-aos="fade-up">
            <div className={styles.imageWrapper}>
              <img src={project1} alt="Data Processing" />
            </div>
            <div className={styles.cardContent}>
              <h4>Data Processing & Enrichment</h4>
              <p className="p-tag" style={{ color: "black" }}>Advanced techniques to process and enrich raw datasets for business insights.</p>
            </div>
          </div>

          <div className={styles.projectCard} data-aos="fade-up">
            <div className={styles.imageWrapper}>
              <img src={project2} alt="Geo Spatial Data" />
            </div>
            <div className={styles.cardContent}>
              <h4>Geo Spatial Data</h4>
              <p className="p-tag" style={{ color: "black" }}>Transforming location intelligence into smart infrastructure planning.</p>
            </div>
          </div>

          <div className={styles.projectCard} data-aos="fade-up">
            <div className={styles.imageWrapper}>
              <img src={project3} alt="MedTech" />
            </div>
            <div className={styles.cardContent}>
              <h4>MedTech for Dynamis</h4>
              <p className="p-tag" style={{ color: "black" }}>Innovative AI-driven solutions for Dynamis MedTech, based in Birmingham, UK.</p>
            </div>
          </div>


        </div>
      </div>


      <div className={styles.contactSection} id="contact">
        <div className={styles.contactOverlay}>
          <h3 className={styles.headingss} data-aos="fade-up">Contact Us</h3>
          <p className={styles.subtext} data-aos="fade-up">
            Let's get this conversation started. Tell us a bit about yourself, and we'll get in touch as soon as we can!
          </p>

          <div className={styles.contactContainer}>
            <div className={styles.contactInfo} data-aos="fade-up">
              <div className={styles.infoItem}>
                <i className="fas fa-map-marker-alt"></i>
                <div>
                  <strong className={styles.sideTitle}>Address</strong>
                  <p className={styles.pTag}> Birmingham, UK</p>
                </div>
              </div>
              <div className={styles.infoItem}>
                <i className="fas fa-phone"></i>
                <div>
                  <strong className={styles.sideTitle}>Phone</strong>
                  <p className={styles.pTag}> +0044 1216888138</p>
                </div>
              </div>
              <div className={styles.infoItem}>
                <i className="fas fa-envelope"></i>
                <div>
                  <strong className={styles.sideTitle}>Email</strong>
                  <p className={styles.pTag}>info@aktech.group</p>
                </div>
              </div>
            </div>

            <form className={styles.contactForm} onSubmit={handleSubmit} data-aos="fade-up">
              <input type="hidden" name="access_key" value="fe327954-4eef-4d64-a223-f81210babc62" />
              <h3 className={styles.headingsss} >Send Message</h3>
              <input
                type="text"
                name="name"
                placeholder="Full Name"
                value={name}
                onChange={handleChange}
                required
              />
              <input
                type="email"
                name="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />

              <textarea
                name="message"
                placeholder="Type your Message..."
                rows="5"
                value={message}
                onChange={handleMessageChange}
                required
              />

              <button type="submit">Send</button>
            </form>
          </div>
        </div>
      </div>




      {/* Footer */}
      <div className={styles.footer}>
        <div className={styles.footerPart}>
          <p>&copy; 2025 AK Technologies Pvt. Ltd. All rights reserved.</p>
        </div>
      </div>
    </>
  );
};

export default AboutUs;
